<form [formGroup]="buildNewVDTypeForm" (ngSubmit)="onSubmit()">
  <div class="form-group select-build-form-group">
    <label class="select-build-visa-type">Select the option that you want to proceed with</label>
    <div class="row">
      <div class="col-4">
        <p-radioButton name="groupname" inputId="build" [value]="'build'" label="Build the visa yourself"
          formControlName="buildVisaType">
        </p-radioButton>
        <label class="select-radio-sub-text" for="build">Start creating the visa form from scratch.</label>
        <label class="select-radio-sub-text" for="build">A blank page that's all you need</label>
      </div>
      <div class="col-4">
        <p-radioButton name="groupname" inputId="pdf" [value]="'pdf'" label="Convert PDF form to workflow"
          formControlName="buildVisaType"></p-radioButton>
        <label class="select-radio-sub-text" for="pdf">Already have a Visa PDF Form?</label>
        <label class="select-radio-sub-text" for="pdf">Just upload and its done</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button type="submit" class="p-btn btn btn-primary mr-3">PROCEED</button>
      <button type="button" class="p-btn btn btn-light" (click)="onCancel()">CANCEL</button>
    </div>
  </div>
</form>
